<pf-section name="kenntnisnahme" [title]="'sendmail.form.kiwi.childbenefit-title' | i18next">

    <p class="ba-copytext">{{ 'sendmail.form.kiwi.childbenefit-text1' | i18next:{childBenefit: childBenefitType} }}</p>

    <p class="ba-copytext"
       [innerHTML]="'sendmail.form.kiwi.childbenefit-text2-' + type.toLowerCase()| i18next:{ linkFamily: linkFamilyHtml}"></p>

    <p class="ba-copytext"
       [innerHTML]="'sendmail.form.kiwi.childbenefit-text3' | i18next:{linkLeaflet: linkLeafletHtml,linkPrivacy: linkPrivacyHtml }"></p>

    <p class="ba-copytext">
        <pf-checkbox controlName="kenntnisnahme" [validate]="validate"
                     [label]="'sendmail.form.kiwi.childbenefit-checkbox-label' | i18next"
                     [validationMessages]="validationMessages"></pf-checkbox>
    </p>

    <p class="ba-copytext">{{ ('sendmail.form.kiwi.childbenefit-legal-' + type.toLowerCase()) | i18next }}</p>

</pf-section>